// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"c0c0532b","455":"4672e1f1","977":"80d3d3a5"}[chunkId] + ".chunk.js";
};